<template>
  <div class="overlay" v-if="isVisible">
    <div class="productSummaryModal">
      <b class="productSummary">{{ mode }} Product</b>
      <hilo-select
        v-if="mode === 'Add'"
        theme="grey"
        style="width: 100%"
        :options="allHiloProducts"
        v-model="selectedProductId"
        @change="selectProduct"
      ></hilo-select>
      <div v-if="selectedProductId" style="width: 100%">
        <div class="detailHeader row">
          <div class="col-4">Price</div>
          <div class="col-4 text-center">{{ selectedProduct.unit }}</div>
          <div class="col-4 float-right">{{ billingPeriod }} Total</div>
        </div>
        <div class="details row">
          <div class="col-5 align-content-center">
            ${{ selectedProduct.pricePerUnit }}
          </div>
          <input
            class="col-2 text-center"
            style="height: 30px !important"
            type="number"
            v-model="productCount"
          />
          <div
            class="col-5 float-right align-content-center"
            v-if="mode === 'Add'"
          >
            ${{
              selectedProduct.pricePerUnit * parseInt(productCount) +
              currentCost
            }}
          </div>
          <div
            class="col-5 float-right align-content-center"
            v-if="mode === 'Edit'"
          >
            ${{
              selectedProduct.pricePerUnit *
                (parseInt(productCount) - originalCount) +
              currentCost
            }}
          </div>
        </div>
      </div>
      <button
        @click="submit"
        :disabled="
          productCount <= 0 || parseInt(productCount) === originalCount
        "
      >
        {{ mode }} Product
      </button>
      <img
        class="closeButton"
        alt=""
        src="/static/img/grey-x.svg"
        @click="closeModal"
      />
    </div>
  </div>
</template>
<script>
import HiloSelect from "../../../../../components/HiloComponents/HiloSelect.vue";
export default {
  name: "ProductsModal",
  components: {
    HiloSelect,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    allHiloProducts: {
      type: Array,
      required: true,
    },
    currentCost: {
      type: Number,
      required: true,
    },
    billingPeriod: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    editProduct: {
      type: Object,
      required: true,
    },
    originalCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedProductId: 0,
      selectedProduct: null,
      productCount: 1,
    };
  },
  mounted() {
    if (this.mode === "Edit") {
      this.selectedProductId = this.editProduct.id;
      this.selectedProduct = this.editProduct;
      this.productCount = this.originalCount;
    }
  },
  methods: {
    selectProduct() {
      this.selectedProduct = this.allHiloProducts.find(
        (data) => data.id === this.selectedProductId,
      );
    },
    closeModal() {
      this.selectedProductId = 0;
      this.productCount = 1;
      this.$emit("close");
    },
    submit() {
      let payload = {
        mode: this.mode,
        productId: this.selectedProductId,
        count: parseInt(this.productCount),
      };
      this.$emit("update", payload);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.float-right {
  text-align: right;
}
.details {
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  margin: 0 10px;
}
.detailHeader {
  padding: 5px 15px;
  margin: 0 10px;
  border-bottom: grey 2px solid;
  font-weight: bold;
}
h3 {
  font-weight: bold;
}
button:disabled {
  opacity: 50%;
  cursor: not-allowed;
}
.productSummary {
  position: relative;
  font-size: 25px;
  white-space: nowrap;
  z-index: 0;
  width: 100% !important;
  text-align: center;
}
.closeButton {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.productSummaryModal {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
